import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from '../ui/ScrollToTop';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-98">
      <ScrollToTop data-id="element-99" />
      <Header data-id="element-100" />
      <main className="flex-grow" data-id="element-101">{children}</main>
      <Footer data-id="element-102" />
    </div>;
}